module.exports = __webpack_public_path__ + "static/gm-30-64ddfdc0936494eb84791a28cdf219e2.jpg";